export type ArtDerBeteiligungEnum = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | '11';

export const ArtDerBeteiligungEnum = {
    PersoenlichHaftenderGesellschafter: '1' as ArtDerBeteiligungEnum,
    Komplementaer: '2' as ArtDerBeteiligungEnum,
    Kommanditist: '3' as ArtDerBeteiligungEnum,
    SonstigerOhneHaftungsbeschraenkung: '4' as ArtDerBeteiligungEnum,
    SonstigerMitHaftungsbeschraenkung: '5' as ArtDerBeteiligungEnum,
    GesellschafterGemeinschafterOhneHaftungsbeschraenkung: '6' as ArtDerBeteiligungEnum,
    GesellschafterGemeinschafterMitHaftungsbeschraenkung: '7' as ArtDerBeteiligungEnum,
    Treuhaender: '8' as ArtDerBeteiligungEnum,
    TreuhaenderNurFuerHaftungsbeschraenkterTreugeber: '9' as ArtDerBeteiligungEnum,
    MittelbarBeteiligterGesellschafter: '10' as ArtDerBeteiligungEnum,
    AusgeschiedeneGesellschafterUndRechtsnachfolger: '11' as ArtDerBeteiligungEnum
};
